import { Component, OnInit } from '@angular/core';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { TenantService } from '@services/api/tenant.service';
import { MatButtonModule } from '@angular/material/button';
import { SystemAdminService } from '@services/system-admin.service';
import { AuthService } from '@services/auth.service';
import { NotAuthenticatedUserError } from '@errors/error';

/** テナントのViewModel */
export type TenantViewModel = {
  /** テナントID */
  tenantId: string;
  /** テナント名 */
  tenantName: string;
  /** 会社ロゴのパス */
  companyLogoPath?: string;
  /** 作成日時 */
  createdAt: string | null;
};

@Component({
  selector: 'app-tenant-select',
  standalone: true,
  imports: [MatGridListModule, MatCardModule, MatButtonModule],
  templateUrl: './tenant-select.component.html',
  styleUrl: './tenant-select.component.scss',
})
export class TenantSelectComponent implements OnInit {
  /** テナント一覧 */
  public tenantList: TenantViewModel[] = [];

  constructor(
    private authService: AuthService,
    private tenantService: TenantService,
    private systemAdminService: SystemAdminService,
  ) {}

  public ngOnInit(): void {
    // テナント一覧を取得する
    this.tenantService.findAll().subscribe({
      next: (tenantList) => {
        this.tenantList = tenantList;
      },
    });
  }

  public saveSystemAdmin(): void {
    const tenantId = this.authService.loggedInUser?.tenant.tenantId;
    if (tenantId == null) {
      throw new NotAuthenticatedUserError();
    }

    this.systemAdminService.setSystemAdminTenant();
    this.systemAdminService.setTenantId(tenantId);
  }

  public saveTenantId(tenantId: string): void {
    this.systemAdminService.setTenantId(tenantId);
  }

  public saveTenantCreatedAt(tenantCreatedAt: string | null): void {
    this.systemAdminService.setTenantCreatedAt(tenantCreatedAt);
  }
}
